import React from 'react';
import {
	ColorStatusGroupHEX,
} from 'utils/color/ColorPalette';
import './FormField.scss';

interface Props<T> {
	value: T;
	setValue: (value: T | undefined) => void;
	/**
	 * Is the placeholder parameter that is displayed inside the input
	 */
	placeholderText: string;
	/**
	 * If the input has value, displays the placeholder as a label
	 */
	usePlaceholderAsLabel?: boolean;
	/**
	 * The action that is performed upon clearing the input
	 */
	onClear?: () => void;
	/**
	 * A hint text for the input field
	 */
	hint?: string;
	error?: any;
	isBlurTriggered?: boolean;
	htmlFor: string;
  children: JSX.Element;
}

export const getFormFieldHtmlForValue = (placeholderText: string) =>
	`input-${(placeholderText || 'field').replaceAll('', '-').toLowerCase()}`;

export const FormField = <T extends string | number | undefined = string>({
	htmlFor = 'input-group',
	children,
	placeholderText,
	usePlaceholderAsLabel,
	isBlurTriggered,
	error,
	value,
	setValue,
	hint,
	onClear,
}: Props<T>) => {
	const styles = {
		size: {
			width: '100%',
		},
		text: {
			color: '#808080',
		},
	};


	return (
		<div className="form-field">
			<div
				style={{
					display: usePlaceholderAsLabel ? 'inherit' : 'none',
					fontWeight: 'normal',
					fontSize: 'small',
					marginBottom: 0,
				}}
			>
				<label
					style={{
						marginBottom: 0,
						visibility: value === null || value === undefined ? 'hidden' : 'inherit',
					}}
					htmlFor={htmlFor}
				>
					{placeholderText}
				</label>
			</div>
			<div
				className="tc-input"
				style={styles.size}
			>
				{children}
				{
					`${value}`.length ? (
						<button
							className="clear-btn"
							type="button"
							onClick={() => {
								setValue(undefined);
								if (onClear) {
									onClear();
								}
							}}
						>
              Clear
						</button>
					) : null
				}
			</div>
			{(error && isBlurTriggered) || hint ? (
				<small style={{
					fontSize: '70%',
					marginTop: 0,
					position: 'absolute',
					color: error && isBlurTriggered ? ColorStatusGroupHEX.alert.primary : ColorStatusGroupHEX.alert.secondary,
				}}
				>
					{error && isBlurTriggered ? error : hint}
				</small>
			) : null}
		</div>
	);
};